/* Hearthfield — progressive enhancement; Shopify retains cart/checkout ownership. */
(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-drawer]').forEach((drawer) => {
      if (drawer.dataset.ready) return;
      drawer.dataset.ready = 'true';
      const opener = document.querySelector(`[aria-controls="${drawer.id}"]`);
      let savedY = 0;
      let previousStyle = '';
      let locked = false;
      function restore() {
        if (!locked || drawer.open) return;
        locked = false;
        document.body.setAttribute('style', previousStyle);
        window.scrollTo({top:savedY, behavior:'instant'});
        opener?.setAttribute('aria-expanded', 'false');
        opener?.focus({preventScroll:true});
      }
      function close() { if (drawer.open) drawer.close(); restore(); }
      opener?.addEventListener('click', () => {
        if (drawer.open) return;
        savedY = window.scrollY;
        previousStyle = document.body.getAttribute('style') || '';
        locked = true;
        drawer.showModal();
        Object.assign(document.body.style, {position:'fixed', top:`-${savedY}px`, width:'100%', overflow:'hidden'});
        opener.setAttribute('aria-expanded', 'true');
      });
      drawer.addEventListener('close', restore);
      drawer.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
      drawer.querySelector('[data-drawer-close]')?.addEventListener('click', close);
      drawer.addEventListener('click', (event) => {
        if (event.target.closest('a')) close();
        const rect = drawer.getBoundingClientRect();
        if (event.target === drawer && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
      });
      // Native modal dialog supplies focus containment, Escape, and background inertness.
      const desktop = matchMedia('(min-width:1101px)');
      desktop.addEventListener('change', () => { if (desktop.matches) close(); });
      document.addEventListener('shopify:section:unload', (event) => { if (event.target.contains(drawer)) close(); });
    });
    scope.querySelectorAll('[data-qty]').forEach((button) => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const input = button.parentElement.querySelector('input');
        if (!input) return;
        const minimum = Number(input.min || 0);
        const maximum = input.max ? Number(input.max) : Infinity;
        input.value = Math.min(maximum, Math.max(minimum, (parseInt(input.value, 10) || minimum) + Number(button.dataset.qty)));
        input.dispatchEvent(new Event('change', {bubbles:true}));
      });
    });
    scope.querySelectorAll('[data-product]').forEach((root) => {
      if (root.dataset.ready) return;
      const data = root.parentElement.querySelector('[data-product-json]');
      if (!data) return;
      let product;
      try { product = JSON.parse(data.textContent); } catch { return; }
      root.dataset.ready = 'true';
      root.classList.add('is-enhanced');
      const idInput = root.querySelector('[data-variant-id]');
      const priceEl = root.querySelector('[data-price]');
      const saleOffer = root.querySelector('[data-sale-offer]');
      const saleSaving = root.querySelector('[data-sale-saving]');
      const addBtn = root.querySelector('[data-add]');
      const payment = root.querySelector('.shopify-payment-button');
      const mainMedia = root.querySelector('[data-main-media] img');
      const fmt = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:window.Shopify?.currency?.active || 'USD'}).format(cents / 100);
      const unitPrice = root.querySelector('[data-unit-price]');
      const bagValue = root.querySelector('[data-bag-value]');
      function bagOunces(variant) {
        for (const option of variant?.options || []) {
          const match = String(option).trim().match(/^(\d+(?:\.\d+)?)\s*(oz|lb)$/i);
          if (match) return Number(match[1]) * (match[2].toLowerCase() === 'lb' ? 16 : 1);
        }
        return 0;
      }
      function syncValue(variant) {
        const ounces = bagOunces(variant);
        if (unitPrice) unitPrice.textContent = ounces ? `${fmt(variant.price / ounces)} / oz` : '';
        if (!bagValue) return;
        bagValue.hidden = true;
        bagValue.textContent = '';
        if (!variant?.available || ounces !== 12) return;
        const sizeIndex = variant.options.findIndex(value => /^(\d+(?:\.\d+)?)\s*(oz|lb)$/i.test(String(value).trim()));
        const larger = product.variants.find(v => v.available && bagOunces(v) === 16 && v.options.every((value,i) => i === sizeIndex || value === variant.options[i]));
        if (!larger) return;
        const difference = larger.price - variant.price;
        if (difference >= 0 && larger.price / 16 < variant.price / 12) {
          bagValue.textContent = difference ? `The 1 lb bag adds 4 oz for ${fmt(difference)} more.` : 'The 1 lb bag adds 4 oz at the same price.';
          bagValue.hidden = false;
        }
      }
      function syncVariant(variant, updateUrl = false) {
        idInput.disabled = !variant;
        addBtn.disabled = !variant?.available;
        addBtn.textContent = !variant ? 'Unavailable combination' : variant.available ? 'Add to cart' : 'Sold out';
        if (payment) payment.hidden = !variant?.available;
        const onSale = !!variant?.available && variant.compare_at_price > variant.price;
        if (saleOffer) saleOffer.hidden = !onSale;
        if (saleSaving) saleSaving.textContent = onSale ? `You save ${fmt(variant.compare_at_price - variant.price)}` : '';
        const saleLabel = root.querySelector('[data-sale-label]'); if (saleLabel) saleLabel.textContent = onSale ? 'On sale' : '';
        priceEl.classList.toggle('price-group--sale', onSale);
        syncValue(variant);
        if (!variant) {
          priceEl.textContent = 'Not available in this combination';
          const url = new URL(location.href); url.searchParams.delete('variant'); history.replaceState({}, '', url);
          return;
        }
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', {bubbles:true}));
        priceEl.textContent = fmt(variant.price);
        if (variant.compare_at_price > variant.price) { const s = document.createElement('s'); s.textContent = fmt(variant.compare_at_price); priceEl.append(s); }
        if (variant.featured_image && mainMedia) {
          mainMedia.src = variant.featured_image.src;
          mainMedia.removeAttribute('srcset');
          mainMedia.alt = variant.featured_image.alt || product.title;
          root.querySelectorAll('[data-thumb]').forEach((b) => b.setAttribute('aria-current', String(b.dataset.mediaId === String(variant.featured_media?.id))));
        }
        if (updateUrl) {
          const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
        }
      }
      syncVariant(product.variants.find(v => String(v.id) === idInput.value));
      root.querySelectorAll('[data-option-index]').forEach((input) => input.addEventListener('change', () => {
        const selected = product.options.map((_, i) => root.querySelector(`[name="option${i + 1}"]:checked`)?.value);
        syncVariant(product.variants.find((v) => v.options.every((value, i) => value === selected[i])), true);
      }));
      root.querySelectorAll('[data-thumb]').forEach((button) => button.addEventListener('click', () => {
        if (!mainMedia) return;
        mainMedia.src = button.dataset.thumb;
        mainMedia.removeAttribute('srcset');
        mainMedia.alt = button.dataset.alt || product.title;
        root.querySelectorAll('[data-thumb]').forEach((b) => b.setAttribute('aria-current', String(b === button)));
      }));
      root.querySelector('[data-product-form]')?.addEventListener('submit', (event) => {
        if (addBtn.disabled || idInput.disabled) event.preventDefault();
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

/* Decorative motion never controls content visibility or checkout behavior. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  const enabledByTheme = document.body.dataset.motion !== 'off';
  let paused = false;
  try { paused = sessionStorage.getItem('hearthfield-motion-paused') === 'true'; } catch {}
  function syncMotion() {
    document.body.dataset.motion = enabledByTheme && !paused && !reduced.matches ? 'on' : 'off';
    document.querySelectorAll('[data-motion-toggle]').forEach(button => {
      button.hidden = !enabledByTheme || reduced.matches;
      button.textContent = paused ? 'Play animations' : 'Pause animations';
      button.setAttribute('aria-pressed', String(paused));
    });
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) {
      if (document.body.dataset.motion === 'on') entry.target.classList.add('motion-enter');
      observer.unobserve(entry.target);
    }
  }, {threshold:.08}) : null;
  function enhance(scope = document) {
    scope.querySelectorAll('.reveal,.section-head,.split__media,.split>div:not(.split__media),.feature,.brew__card,.faq').forEach(el => {
      if (el.dataset.motionReady) return;
      el.dataset.motionReady = 'true';
      const siblings = Array.from(el.parentElement.children);
      el.style.setProperty('--reveal-delay', `${Math.min(siblings.indexOf(el) % 4, 3) * 70}ms`);
      observer?.observe(el);
    });
    scope.querySelectorAll('[data-motion-toggle]').forEach(button => {
      if (button.dataset.motionReady) return;
      button.dataset.motionReady = 'true';
      button.addEventListener('click', () => {
        paused = !paused;
        try { sessionStorage.setItem('hearthfield-motion-paused', String(paused)); } catch {}
        syncMotion();
      });
    });
    scope.querySelectorAll('[data-coffee-scene]').forEach(scene => {
      if (scene.dataset.motionReady) return;
      scene.dataset.motionReady = 'true';
      scene.addEventListener('pointermove', event => {
        if (document.body.dataset.motion !== 'on' || !finePointer.matches) return;
        const rect = scene.getBoundingClientRect();
        scene.style.setProperty('--scene-x', `${((event.clientX - rect.left) / rect.width - .5) * 14}px`);
        scene.style.setProperty('--scene-y', `${((event.clientY - rect.top) / rect.height - .5) * 10}px`);
      }, {passive:true});
      scene.addEventListener('pointerleave', () => {scene.style.setProperty('--scene-x','0px');scene.style.setProperty('--scene-y','0px');});
    });
    syncMotion();
  }
  document.addEventListener('visibilitychange', () => document.body.classList.toggle('motion-idle', document.hidden));
  reduced.addEventListener('change', syncMotion);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-motion-ready]').forEach(el=>observer?.unobserve(el)));
  enhance();
})();
